import React, {useCallback, useState} from "react";
import {connect} from "react-redux";
import LoggedOutLayout from "features/layouts/pages/logged-out";
import {ALLOWED_SUBSCRIPTION_TYPES_ON_SIGNUP, SUBSCRIPTIONS_DETAIL} from "constants.js";
import {Redirect} from "react-router";
import {AppAreasRedirects} from "services/utils/utils";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import "./index.scss";
import {Stepper, StepperStep} from "features/components/stepper";
import SignupForm, {SignupBaseState} from "features/forms/signup";
import PaymentForm from "features/forms/payment";
import InvoiceForm, {InvoiceFormBaseState} from "features/forms/invoice";
import PaymentInfoBox from "features/components/payment-info-box";
import {Icon} from "features/components/icon";
import {signupError, signupLoading} from "features/pages/account/signup/selectors";
import {signupStart} from "features/pages/account/signup/reducer";
import {Analytics} from "services/analytics";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: signupLoading(state),
    error: signupError(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    sendSignup: signupStart
};

export const SignUpPage = (props) => {
    const {sendSignup, loading, error} = props;
    const {type} = props.match.params;
    const [signup, setSignup] = useState(SignupBaseState);
    const [payment, setPayment] = useState({});
    const [invoice, setInvoice] = useState(InvoiceFormBaseState);
    const subscriptionDetails = SUBSCRIPTIONS_DETAIL[type];

    const confirmAndPay = useCallback(() => {
        const data = {
            signup, payment, invoice, type: subscriptionDetails.server_id
        };
        sendSignup(data);
    }, [signup, payment, invoice, sendSignup, subscriptionDetails]);

    React.useEffect(() => {
        Analytics.trackInitiateCheckout();
    }, []);

    if(!ALLOWED_SUBSCRIPTION_TYPES_ON_SIGNUP.includes(type)) {
        return <Redirect to={AppAreasRedirects.LoggedOut} />
    }
    return <LoggedOutLayout type={"light"} className={"signup-page"}>
        <div className={"sidebar-wrapper"}>
            <div className="sidebar">
                <Title size={34}>{__("signup.sidebar.title")}</Title>
                <Text size={16}>{__("signup.sidebar.text")}</Text>
            </div>
            <div className="content">
                <Stepper onComplete={confirmAndPay}>
                    <StepperStep stepperValidation={() => !!signup.valid}>
                        <div className={"white-box"}>
                            <div className={"row"}>
                                <Title size={24}>{__("signup.step1.title")}</Title>
                                <Title className={"step"} size={16}>{__("common.step")} 1</Title>
                            </div>
                            <SignupForm {...signup} onChange={setSignup} />
                        </div>
                    </StepperStep>
                    <StepperStep stepperLoading={loading}
                                 stepperValidation={() => !!payment.valid && !!invoice.valid}
                                 stepperTitle={__("signup.step2.enter-osa", [{key: "[price]", value: subscriptionDetails.price}])}>
                        <div className={"white-box step2"}>
                            <div className={"row"}>
                                <Title size={24}>{__("signup.step2.title")} {subscriptionDetails.name}</Title>
                                <Title className={"step"} size={16}>{__("common.step")} 2</Title>
                            </div>
                            <PaymentInfoBox
                                title={__("signup.step2.payment_title", [{key: "[sub-name]", value: subscriptionDetails.name}])}
                                price={__("common.price-yearly", [{key:"[price]", value: subscriptionDetails.price}])}>
                                {subscriptionDetails.benefits.map(
                                    item => <div key={item} className={"row benefits"}>
                                    <Icon>check-circle-outline</Icon><Text size={16}>{item}</Text>
                                </div>)}
                            </PaymentInfoBox>
                            <PaymentForm {...payment} onChange={setPayment} />
                            <InvoiceForm {...invoice} onChange={setInvoice} />
                            {error.inError && <Text size={18} color={"danger"} align={"center"}>{__(error.error)}</Text>}
                        </div>
                    </StepperStep>
                </Stepper>
            </div>
        </div>
    </LoggedOutLayout>
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);